import type { ReactElement } from 'react';
import { useState } from 'react';

import {
  BpkAccordionItem,
  withAccordionItemState,
} from '@skyscanner-internal/backpack-web/bpk-component-accordion';
import { TEXT_STYLES } from '@skyscanner-internal/backpack-web/bpk-component-text';

import FooterLinkList from '../FooterLinkList';
import { mbdTrackingParams } from '../helpers/mbd';

import type { Strings, LinkGroup } from '../Footer';

import STYLES from './FooterGroup.module.scss';

const BpkStatefulAccordionItem = withAccordionItemState(BpkAccordionItem);

type Props = LinkGroup & {
  strings: Pick<Strings, 'expand' | 'close'>;
};

const FooterGroup = ({ heading, id, links, strings }: Props): ReactElement => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <>
      {links.length > 0 && (
        <BpkStatefulAccordionItem
          id={`${id}-group`}
          className={STYLES['footer-group']}
          expanded={expanded}
          onClick={() => setExpanded(!expanded)}
          tagName="span"
          title={heading}
          textStyle={TEXT_STYLES.label2}
          data-tracking-element-id={`footer_group_${id}`}
          data-tracking-common-params={mbdTrackingParams('footer_group', { group_id: id })}
        >
          <FooterLinkList links={links} expanded={expanded} strings={strings} />
        </BpkStatefulAccordionItem>
      )}
    </>
  );
};

export default FooterGroup;
